import { Box } from '@mui/material';
import classNames from 'classnames';
import React, { FC } from 'react';
import FreeWinResultImage from 'assets/images/YouWon.png';
import { useStyles } from './FreeWinResult.styles';

interface FreeWinResultProps {
  isVideoEnded: boolean;
}

export const FreeWinResult: FC<FreeWinResultProps> = ({ isVideoEnded }) => {
  const { classes } = useStyles();

  return (
    <Box className={classNames(classes.root, { [classes.fadeIn]: isVideoEnded })}>
      <img src={FreeWinResultImage} alt="you-won" />
    </Box>
  );
};
